<div class="favorite-layers-dialog">
    <div class="title-row">
        <div class="title-block">
            <div class="title">Choose layers to load</div>
            <p class="description">
                Large groups don't show every layer by default. Only loaded layers appear in the
                layer list.
            </p>
        </div>
        <cds-button
            *ngIf="loadedLayersCount > 0"
            size="sm"
            action="flat"
            (click)="deselectAllLoaded()"
            title="Unload all layers in this group"
        >
            Unload all
        </cds-button>
    </div>
    <div class="filter-row">
        <cds-icon shape="search"></cds-icon>
        <input
            #filterInput
            type="text"
            placeholder="Filter by name"
            [(ngModel)]="filterText"
            class="filter-input"
        />
    </div>
    <div class="load-status-row">
        <button
            type="button"
            class="status-filter"
            [class.active]="loadStatusFilter === 'all'"
            (click)="setLoadStatusFilter('all')"
        >
            All
        </button>
        <button
            type="button"
            class="status-filter"
            [class.active]="loadStatusFilter === 'loaded'"
            (click)="setLoadStatusFilter('loaded')"
        >
            Loaded ({{ loadedLayersCount }})
        </button>
        <button
            type="button"
            class="status-filter"
            [class.active]="loadStatusFilter === 'unloaded'"
            (click)="setLoadStatusFilter('unloaded')"
        >
            Unloaded ({{ unloadedLayersCount }})
        </button>
    </div>
    <div class="content">
        <p *ngIf="allLayersCount === 0" class="empty-message">
            All layers in this group are loaded.
        </p>
        <p
            *ngIf="allLayersCount > 0 && displayedLayers.length === 0 && hiddenLayerCount === 0"
            class="empty-message"
        >
            No layers match filter.
        </p>
        <ul *ngIf="displayedLayers.length > 0" class="layer-list">
            <li *ngFor="let layer of displayedLayers; trackBy: trackByLayerId" class="layer-row">
                <span class="layer-name" [class.unloaded]="!layer.loaded">{{ layer.name }}</span>
                <button
                    *ngIf="!layer.loaded"
                    class="icon-button"
                    (click)="addLayer(layer)"
                    title="Load layer"
                >
                    <cds-icon shape="plus"></cds-icon>
                </button>
                <button
                    *ngIf="layer.loaded"
                    class="icon-button"
                    (click)="removeLayer(layer)"
                    title="Unload layer"
                >
                    <cds-icon shape="minus"></cds-icon>
                </button>
            </li>
            <li *ngIf="hiddenLayerCount > 0" class="layer-row truncated-hint">
                … {{ hiddenLayerCount | number }} more layers not shown
            </li>
        </ul>
    </div>
    <div class="actions">
        <cds-button size="sm" action="flat" (click)="close()">Close</cds-button>
    </div>
</div>
